const cfdDelinquencyDistrictReport = {
  label: "CFD Delinquency Report - District",
  name: "cfdDelinquencyDistrictReport",
  parameters: [
    {
      name: "taxYear",
      label: "Tax year",
      type: "year",
      defaultValue: "2025",
    },
    {
      name: "countyId",
      label: "County",
      type: "dbfield",
      db: "cfd_nehal",
      table: "County",
      keyField: "CountyId",
      valueField: "Name",
      fields: ["County.CountyId", "County.Name"],
      distinct: true,
      join: {
        Parcel: "CountyId",
      },
      sort: {
        Name: "asc",
      },
    },
    {
      name: "districtId",
      label: "District",
      type: "dbfield",
      db: "cfd_nehal",
      table: "District",
      keyField: "DistrictId",
      valueField: "DistrictName",
      fields: ["District.DistrictId", "District.DistrictName"],
      distinct: true,
      join: {
        Parcel: "DistrictId",
      },
      sort: {
        DistrictName: "asc",
      },
      dependsOn: "countyId",
      noDependsOnDisable: true,
    },
    {
      name: "includeParcelsWithoutLevy",
      label: "Include parcels w/o levy",
      type: "select",
      defaultValue: "yes",
      options: [
        { key: "yes", label: "Yes" },
        { key: "no", label: "No" },
      ],
    },
  ],
};

export default cfdDelinquencyDistrictReport;
